import { createContext } from 'react';

import { IntegrationSystem } from '@/shared/types';

import { FeatureName, ResponseFeatures } from '@/api/types';

export type FeatureContextType = {
  isFeatureAvailable: (key: FeatureName) => boolean;
  getFeatureDetails: <T extends FeatureName>(key: T) => ResponseFeatures[T][1];
  getSourceSystemByFeature: (key: FeatureName) => Nullable<IntegrationSystem>;
};

export const FeatureContext = createContext<FeatureContextType>({
  isFeatureAvailable: () => false,
  getFeatureDetails: () => null,
  getSourceSystemByFeature: () => null,
});
